export default __webpack_public_path__ + "static/media/homepage-showcase.969e9274.png";